import * as React from 'react';
export function PluginRequiredMessage(props) {
    return (React.createElement(React.Fragment, null,
        props.trans.__('The plugin "%1" cannot be disabled as it is required by other plugins:', props.plugin.id),
        React.createElement("ul", null, props.dependants.map(plugin => (React.createElement("li", { key: 'dependantsDialog-' + plugin.id }, plugin.id)))),
        props.trans.__('Please disable the dependant plugins first.')));
}
export function PluginInUseMessage(props) {
    return (React.createElement("div", { className: 'jp-pluginmanager-PluginInUseMessage' },
        props.trans.__('While the plugin "%1" is not required by other enabled plugins, some plugins provide optional features depending on it. These plugins are:', props.plugin.id),
        React.createElement("ul", null, props.optionalDependants.map(plugin => (React.createElement("li", { key: 'optionalDependantsDialog-' + plugin.id }, plugin.id)))),
        props.trans.__('Do you want to disable it anyway?')));
}
//# sourceMappingURL=dialogs.js.map